import { render, staticRenderFns } from "./ImageGBS.vue?vue&type=template&id=2989501a&scoped=true&"
import script from "./ImageGBS.vue?vue&type=script&lang=js&"
export * from "./ImageGBS.vue?vue&type=script&lang=js&"
import style0 from "./ImageGBS.vue?vue&type=style&index=0&id=2989501a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989501a",
  null
  
)

export default component.exports